export const fmt0 = (x) => (x ?? x === 0 ? Number(x).toFixed(0) : '—');
export const fmt1 = (x) => (x ?? x === 0 ? Number(x).toFixed(1) : '—');
export const fmt2 = (x) => (x ?? x === 0 ? Number(x).toFixed(2) : '—');
export const fmt3 = (x) => (x ?? x === 0 ? Number(x).toFixed(3) : '—');
export const fmt4 = (x) => (x ?? x === 0 ? Number(x).toFixed(4) : '—');

export const fmtTooltipPrice0 = (x) => (Number.isFinite(Number(x)) ? String(Math.round(Number(x))) : '--');
export const fmtSessionDateET = (ms) => {
  const t = Number(ms);
  if (!Number.isFinite(t)) return '--';
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    month: 'short',
    day: '2-digit',
  }).formatToParts(new Date(t));
  const month = parts.find(({ type }) => type === 'month')?.value;
  const day = parts.find(({ type }) => type === 'day')?.value;
  return month && day ? `${month}-${day}` : '--';
};

export function heatStyle(value, huePos = 200, hueNeg = 0, max) {
  if (value === undefined || value === null || isNaN(value)) return {};
  const v = Math.abs(Number(value));
  const denom = max ?? (v === 0 ? 1 : v);
  const norm = Math.min(1, Math.pow(v / denom, 0.5));
  const hue = Number(value) >= 0 ? huePos : hueNeg;
  const alpha = 0.1 + 0.22 * norm;
  return { backgroundColor: `hsla(${hue} 90% 50% / ${alpha})` };
}
